import Head from 'next/head';
import React, { useEffect, useState } from 'react';
import { getCurrentUser } from "New/serverRequests/requests";
import withAuth from 'PublishedNew/components/withAuth';

function HeaderUser() {
	const [currentUser, setCurrentUser] = useState({});
	const {credits, plans, username} = currentUser;
	const [openMobileMenu, setOpenMobileMenu] = useState(false);
	const refershTriggerComponents = ['delete-plan-button', 'refresh-button', 'edit-button', 'new', 'publish-button', 'unpublish-button']

	const loadCurrentUser = () => {
        getCurrentUser().then((result) => {
            setCurrentUser(result);
            if (result.pending_credits > 0) {
                setTimeout(() => {
                    loadCurrentUser();
                }, 5000)
            }
        });
    }
	
	useEffect(() => {
		let to;
		loadCurrentUser();
		(function ($) {
			$(document).ready(function () {
				$(document).on("click",".mainApp button", function () {
					$(".header").hide();
					$(".header").addClass("not_first_step");
				});
				$(".tempWrap").on("click", function () {
					$(".header").hide();
					$(".header").addClass("not_first_step");
				});
				$(document).on('click', '.firstOpt .fa.fa-caret-up', function() {
					$("body").removeClass("first_step");
					$(".header").slideDown();
					$(".header").css({
						"position": "absolute",
						"width": "100%",
						"z-index": "999"
					});
				});
				$(document).mouseup(function (e){
					var modalctr = $("body");   
					var modal = $(".header.not_first_step");
					if (!modal.is(e.target) && modal.has(e.target).length === 0){
						modal.slideUp();

					}
				});
		
				$(document).on('click', '.accountBtn a', function () {
					$(".otherTools").fadeToggle();
				});

				// $(document).on('click', '.publishBtn', function(e) {
				// 	$(".header").slideDown();
				// 	$(".header").css({
				// 		"position": "absolute",
				// 		"width": "100%",
				// 		"z-index": "999"
				// 	});
				// })
			});
		})(jQuery);

		document.addEventListener('click', (e) => {
			setTimeout(() => {
				if (refershTriggerComponents.includes(e.target.className)) {
					loadCurrentUser();
				}
			}, 500)
			
		})
		return () => clearTimeout(to);
	},[])

    return <>
        <Head>
            <title>iFloorPlan</title>
	        <meta name='viewport' content='width=device-width, initial-scale=1.0' />
            {/* {% load static %} */}
			<script src="https://ajax.googleapis.com/ajax/libs/jquery/2.1.1/jquery.min.js"></script>
            <link rel='stylesheet' type='text/css' href='/static/public/css/index.css'/>
	        <link rel='stylesheet' type='text/css' href='/static/user/css/main.css'/>
	        <link rel='stylesheet' href='/static/user/fonts/font-awesome/css/font-awesome.min.css' />
	        <link rel='stylesheet' href='/static/user/fonts/font-awesome/css/font-awesome.css' />
	        <link rel='stylesheet' href='/static/user/fonts/simple-line-icons/simple-line-icons.css' />
	        <link href="https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700&amp;subset=cyrillic" rel="stylesheet" />
	        <link rel='stylesheet' href='https://use.fontawesome.com/releases/v5.6.1/css/all.css'
			integrity='sha384-gfdkjb5BdAXd+lj+gudLWI+BXq4IuLW5IT+brZEZsLFm++aCMlF1V92rMkPaX4PP' crossorigin='anonymous' />
	        <link href='https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap' rel='stylesheet'></link>
		    <link href='https://fonts.googleapis.com/css2?family=IBM+Plex+Serif:ital,wght@0,400;0,700;1,400;1,700&display=swap' rel='stylesheet' />
		    <link href='https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,700;1,400;1,700&display=swap' rel='stylesheet' />
        </Head>
        
  	<div className="header">
		<div className="row top_row">
			<div className="one">
				<a className="logo" href="https://ifloorplan.com/" style={{ lineHeight: 0}}>
					<img src="/static/public/img/logo.png"
						width="187" />
				</a>
				<div className='mobile-menu'
					onClick={() => {
						setOpenMobileMenu(!openMobileMenu);
					}}>
					<i className="fa fa-bars"></i>
				</div>
				<ul className='mobile-menu-options' 
					style={{
						display: openMobileMenu ? 'block' : 'none'
					}}>
					<li><a href="/user/myiFloorPlans">My iFloorPlans</a></li>
					<li><a href="/user/purchase">Purchase</a></li>
					<li><a href="/user/email_change">Change Email Address</a></li>
					<li><a href="/user/pass_change">Change password</a></li>
					<li><a href="/logout/">Sign out</a></li>
				</ul>
			</div>
			<div className="two">
				<p className="user">Hello <i>{username}</i></p>
				<p className="info">You have {plans} Published iFloorPlans and {credits} credits</p>
			</div>
		</div>
		<div className="row bot_row">
			<div className="one">
				<ul className="nav nav-tabs">
					{/* <li className="active"><a href="/user/new">New</a></li> */}
					<li><a href="/user/myiFloorPlans">My iFloorPlans</a></li>
					<li><a href="/user/clients">Clients</a></li>
					<li><a href="/user/branding">Branding</a></li>
					<li><a href="/user/templates">Templates</a></li>
					<li><a href="/user/markers">Markers</a></li>
					<li><a href="/user/userguide">Support</a></li>
				</ul>
			</div>
			<div className="two">
				<ul className="nav_active">
				{/* {(typeof window !== "undefined") ? window.location.hostname === 'app.ifloorplan.com' ? 
				 '' : */}
				 <li><a href="/user/purchase">Purchase</a></li>
				{/* //  : ''} */}
					<li>
						<div className="accountBtn">
							<a href="#">Account</a>
							<div className="otherTools">
								<div className="subOtherTools">
									<a href="/user/pass_change">Change password</a>
								<a href="/user/email_change">Email preferences</a>
								{/* <a href="/user/domain">Domain API</a>
								<a href="/user/snapshot">Account snapshot</a>
								<a href="/user/country_term">Country terminology</a> */}
								<a href="/logout/">Logout</a>
								</div>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<input type="hidden" id="user_id" value={currentUser.userid} />
    </>
}

export default withAuth(HeaderUser);